import { wsService } from "../wsService";

function getAllProvince() {
  return wsService.make_get_request("provinces");
}

export const provincesService = {
  getAllProvince,
};
